import { ReactNode } from "react";
import { useEffect } from 'react';
import { AuthProvider } from "./auth";
import { DoctorsDataProvider } from "./doctorsData";
import { FilterProvider } from "./filters";
import { GeolocationProvider } from "./geolocation";
import { PartnerDataProvider } from "./partnerData";
import { ScheduleAvailabilityProvider } from "./scheduleAvailability";
import { ScheduleProvider } from "./schedule";
import { UserProvider } from "./user";

interface IProvidersProps {
  children: ReactNode;
}

export const useDocumentTitle = (title = "Conectadoc Partner") => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = (title != "Conectadoc Partner") ? `${title} | By Conectadoc` : title;
    return () => {
      document.title = previousTitle; // restaura o título anterior
    };
  }, [title]);
};

const Providers = ({ children }: IProvidersProps) => {
  return (
    <AuthProvider>
      <GeolocationProvider>
        <PartnerDataProvider>
          <UserProvider>
            <FilterProvider>
              <DoctorsDataProvider>
                <ScheduleAvailabilityProvider>
                  <ScheduleProvider>
                    {children}
                  </ScheduleProvider>
                </ScheduleAvailabilityProvider>
              </DoctorsDataProvider>
            </FilterProvider>
          </UserProvider>
        </PartnerDataProvider>
      </GeolocationProvider>
    </AuthProvider>
  );
};

export default Providers;
